<template>
    <div class="search-shell">
        <i class="fas fa-search search-icon"></i>
        <input
          type="text"
          class="search-input"
          v-model="searchQuery"
          :placeholder="searchPlaceholder"
          @input="submit"
          @keypress.enter.prevent="submit"
        />
        <button class="search-button" @click="submit" @keypress.enter.prevent="submit">{{ buttonPlaceholder }}</button>
    </div>
</template>

<script setup>
import { defineProps, ref, defineEmits } from 'vue';

const props = defineProps({
    searchPlaceholder: {
      type: String,
    },
    buttonPlaceholder: {
        type: String,
    }
  });

const searchQuery = ref('');

const emit = defineEmits(['OutputSearch']);

const submit = () => {
  emit('OutputSearch', searchQuery.value);
};

</script>

<style scoped>
.search-shell {
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 6px 0 13px;
  border: 1px solid var(--ui-border, rgba(110, 43, 146, 0.14));
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.04);
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.search-shell:focus-within {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px var(--ui-ring, rgba(186, 111, 215, 0.18));
}

.search-icon {
  color: var(--ui-muted, #75657f);
  font-size: 0.9rem;
}

.search-input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  color: var(--ui-text, #171225);
  font-size: 0.92rem;
}

.search-input::placeholder {
  color: var(--ui-muted, #75657f);
}

.search-button {
  min-height: 34px;
  border: 0;
  border-radius: 8px;
  padding: 0 13px;
  background: var(--primary-color);
  color: white;
  font-size: 0.82rem;
  font-weight: 650;
  transition: background 0.18s ease, transform 0.18s ease;
}

.search-button:hover {
  background: var(--primary-hover);
  transform: translateY(-1px);
}

@media (max-width: 520px) {
  .search-button {
    display: none;
  }
}
</style>
